module.exports = __webpack_public_path__ + "img/imgSrc2.7d95983a.png";